"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var index_1 = require("../../index");
var shortlink_1 = __importDefault(require("../util/shortlink"));
var GoSwitch_1 = __importDefault(require("../../../../widgets/GoSwitch"));
var ConfigOption_1 = __importStar(require("../../../../widgets/ConfigOption"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        activeText: {
            color: '#FFC700',
        },
        inactiveText: {
            color: '#B01E1E',
        },
        regularText: {
            fontWeight: 400,
        },
        stateSwitch: {
            marginTop: 0,
            marginBottom: theme.spacing(4),
        },
    });
});
function LinkStateText() {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var classes = useStyles();
    var drawerStates = index_1.useDrawerState();
    // Fetch short link state and dispatches from redux store through our helper hook.
    var _b = shortlink_1.default(drawerStates.relevantShortLink), shortLinkState = _b.shortLinkState, shortLinkDispatch = _b.shortLinkDispatch;
    var stateTitleActive = (react_1.default.createElement(react_1.default.Fragment, null,
        t('editLink.yourLinkIs'),
        ' ',
        react_1.default.createElement("span", { className: classes.activeText }, t('editLink.active')),
        ' ',
        t('editLink.publiclyAccessible')));
    var stateTitleInactive = (react_1.default.createElement(react_1.default.Fragment, null,
        t('editLink.yourLinkIs'),
        ' ',
        react_1.default.createElement("span", { className: classes.inactiveText }, t('editLink.inactive')),
        ' ',
        t('editLink.notPubliclyAccessible')));
    return (react_1.default.createElement(ConfigOption_1.default, { title: [
            (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.state) === 'ACTIVE'
                ? stateTitleActive
                : stateTitleInactive,
            // <Typography variant="body2" className={classes.regularText}>
            //   Share your link through{' '}
            //   <a href="https://postman.gov.kh" target="_blank" rel="noreferrer">
            //     Postman
            //   </a>
            //   , a mass messaging tool.
            // </Typography>,
        ], mobile: true, trailing: react_1.default.createElement("div", { style: { paddingTop: 30 } },
            react_1.default.createElement(GoSwitch_1.default, { color: "primary", checked: (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.state) === 'ACTIVE', onChange: shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.toggleStatus, className: classes.stateSwitch })), trailingPosition: ConfigOption_1.TrailingPosition.none, leadingContainerOrder: 2, trailingOrder: 1 }));
}
exports.default = LinkStateText;
